
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sound/[...p]",
      function () {
        return require("private-next-pages/sound/[...p].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sound/[...p]"])
      });
    }
  